import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { FunctionsService } from 'src/app/services/functions.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './status-modal.component.html'
})
export class StatusModalComponent implements OnInit {
  @Input() message: string;
  @Input() message2: string;
  @Input() reason: string;
  @Input() alertId: number;
  @Input() agentName: string;
  @Input() title: string;
  @Input() closedAlert: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    public functionsService: FunctionsService,
    public translate: TranslateService
  ) { }

  modalTimer: any = localStorage.getItem('modalTimer');
  interval: any;

  ngOnInit() {
    if(this.agentName){
      this.message = this.translate.instant(this.message, {alertId: this.alertId, agent: this.agentName});
    }
    if(this.reason){
      this.message2 = this.translate.instant(this.message2) + this.reason;
    }
    this.modalTimer = this.modalTimer == null ? 300000 : this.modalTimer;
    this.interval = setInterval(()=> { this.activeModal.close(false); clearInterval(this.interval) }, this.modalTimer)
  }
}
